<div style="display: inline-block" class="'button_right-spacing'">
  @if (icon && text) {
    <button
      class="button_primary button_var_2"
      style="display: flex; align-items: center; gap: 8px"
      (click)="btnClick()"
      (mouseover)="btnMouseOver()"
      [title]="title"
    >
      <app-icon
        [hidden]="!icon"
        [type]="icon"
        [class]="'small'"
        [color]="'#ffffff'"
        [style]="'padding:0px; margin:0px; margin-bottom:-3px;'"
      ></app-icon>
      <span>{{ text }}</span>
    </button>
  }

  <app-icon
    [hidden]="(icon && text) || (!icon && text)"
    [type]="icon"
    [class]="'small'"
    [color]="'#127E99'"
    [style]="'cursor:pointer;'"
    (click)="btnClick()"
    (mouseover)="btnMouseOver()"
    [title]="title"
  ></app-icon>
  @if (!((icon && text) || (!text && icon))) {
    <input
      [hidden]=""
      type="button"
      [value]="text"
      class="button_primary button_var_2"
      (click)="btnClick()"
    />
  }
</div>
